<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Migrar ' | translate}} {{'grupos' | nomenclatura | async}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>
  <ion-card class="gradient-extendido-recuo" *ngIf="gruposSelect.length">
    <ion-grid>
      <ion-row class="ion-justify-content-center">
        <ion-col size="auto">
          <p>
            {{'Selecione para qual Grupo a pessoa deve ser migrada como participante:' | translate}}
            <span class="danger">{{'Atenção! A pessoa será removida dos não selecionados!' | translate}}</span>
          </p>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-card-content class="remove-border">
      <ion-list>
        <ion-item *ngFor="let grupo of gruposSelect;">
          <ion-toggle justify="space-between" [(ngModel)]="grupo.selected" class="item-title" [enableOnOffLabels]="true">
            {{grupo.nome}}
          </ion-toggle>
        </ion-item>
      </ion-list>
    </ion-card-content>

    <ion-grid>
      <ion-row class="ion-justify-content-center">
        <ion-col size="auto">
          <div>
            <ion-button expand="block" class="btn-default" (click)="selecionarGrupos();">
              {{'Selecionar' | translate}}
            </ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>

  <ion-grid *ngIf="!gruposSelect.length">
    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <sem-registro></sem-registro>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
